
import { UiTitle } from '~/components/atoms'

export default {
  name: 'BusinessCarousel',
  components: {
    UiTitle,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {}
  },
}
